import { ComponentProps, forwardRef } from "react";

const DocumentCopyIcon = forwardRef<SVGSVGElement, ComponentProps<"svg">>((props, svgRef) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    ref={svgRef}
  >
    <path
      d="M10.0516 16.5779H1.14844C0.993037 16.5779 0.844002 16.5162 0.734117 16.4063C0.624233 16.2964 0.5625 16.1474 0.5625 15.992V4.62207C0.5625 4.46667 0.624233 4.31763 0.734117 4.20775C0.844002 4.09787 0.993037 4.03613 1.14844 4.03613H10.0516C10.207 4.03613 10.356 4.09787 10.4659 4.20775C10.5758 4.31763 10.6375 4.46667 10.6375 4.62207V15.992C10.6375 16.1474 10.5758 16.2964 10.4659 16.4063C10.356 16.5162 10.207 16.5779 10.0516 16.5779ZM1.73438 15.4061H9.46563V5.20801H1.73438V15.4061Z"
      fill="currentColor"
    />
    <path
      d="M13.2127 13.4168H10.0514C9.89597 13.4168 9.74693 13.3551 9.63705 13.2452C9.52716 13.1353 9.46543 12.9863 9.46543 12.8309C9.46543 12.6755 9.52716 12.5264 9.63705 12.4165C9.74693 12.3067 9.89597 12.2449 10.0514 12.2449H12.6268V2.04687H4.89551V4.62187C4.89551 4.77727 4.83377 4.92631 4.72389 5.03619C4.61401 5.14608 4.46497 5.20781 4.30957 5.20781C4.15417 5.20781 4.00513 5.14608 3.89525 5.03619C3.78536 4.92631 3.72363 4.77727 3.72363 4.62187V1.46094C3.72363 1.30554 3.78536 1.1565 3.89525 1.04662C4.00513 0.936733 4.15417 0.875 4.30957 0.875H13.2127C13.3681 0.875 13.5171 0.936733 13.627 1.04662C13.7369 1.1565 13.7986 1.30554 13.7986 1.46094V12.8309C13.7986 12.9863 13.7369 13.1353 13.627 13.2452C13.5171 13.3551 13.3681 13.4168 13.2127 13.4168Z"
      fill="currentColor"
    />
  </svg>
));

DocumentCopyIcon.displayName = "DocumentCopyIcon";

export default DocumentCopyIcon;
